import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
import { ECOSYSTEM_SOURCE } from '../data/ecosystem';
const segments = ['Venture capital funds', 'Corporate venture teams', 'Family offices', 'Angel networks', 'Accelerators and venture programs', 'Institutional ecosystem organizations'];
const path = ['Diligence', 'Deal-flow management', 'Portfolio intelligence', 'LP reporting', 'Organization-level memory', 'Ecosystem intelligence'];
export function MarketEntrySlide() {
  return <Slide index={12} source={ECOSYSTEM_SOURCE} data-id="element-190" data-mp="2r7q3zkqiz44q">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-191" data-mp="2r916zic5c7us">
        <div className="max-w-[62%]" data-id="element-192" data-mp="2w7ch7u6cskdj">
          <Eyebrow data-id="element-193" data-mp="2w46rccpwhegr">Market entry</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-194" data-mp="2h8ifq2i95p2u">
            Enter through investment workflows, expand into venture
            infrastructure.
          </Title>
        </div>
        <Caption className="max-w-[26%] text-right" data-id="element-195" data-mp="2m9y15vocdxlr">
          Bottom-up addressable universe of organizations — not a claimed
          customer count.
        </Caption>
      </div>

      <div className="mt-auto grid grid-cols-[40%_1fr] gap-[3.4vw]" data-id="element-196" data-mp="28e9qeawxempg">
        <div data-id="element-197" data-mp="2md9enhgj0zl3">
          <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#3B8CFF]" data-id="element-198" data-mp="2mdr7e43zcvo9">
            Initial customer focus
          </span>
          <ul className="mt-[2vh] space-y-[1.3vh]" data-id="element-199" data-mp="1umv3vu3t83dn">
            {segments.map(s => <li key={s} className="border-b border-white/8 pb-[1.3vh] text-[clamp(10.5px,1.14vw,24px)] text-[#DCE3EE]" data-id="element-200" data-mp="1po09rw0e6se8">
                {s}
              </li>)}
          </ul>
        </div>

        <div className="flex flex-col justify-end" data-id="element-201" data-mp="1ynwxnveyjn88">
          <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#2FBE8F]" data-id="element-202" data-mp="1ayvtikd5qy8r">
            Expansion path
          </span>
          <div className="mt-[2.4vh] space-y-[1.4vh]" data-id="element-203" data-mp="16x0u5leseuxm">
            {path.map((step, i) => <Reveal key={step} delay={0.07 * i} className="flex items-center gap-[1.2vw]" data-id="element-204" data-mp="361is843trulj" data-mpi={i}>
                <span className="h-[0.9vh] rounded-full" style={{
              width: `${18 + i * 11}%`,
              background: `rgba(47,190,143,${0.35 + i * 0.1})`
            }} data-id="element-205" data-mp="3fsdg1cwpz293" />
                <span className="text-[clamp(10.5px,1.14vw,24px)] text-[#DCE3EE]" data-id="element-206" data-mp="2n595kseuxvpx">
                  {step}
                </span>
              </Reveal>)}
          </div>
        </div>
      </div>

      <Reveal delay={0.44} className="mt-[3vh] flex items-end justify-between border-t border-white/12 pt-[2.2vh]" data-id="element-207" data-mp="2x3ox2whsr6zy">
        <div className="flex gap-[3vw]" data-id="element-208" data-mp="cbwjnb1vkjqx">
          <div data-id="element-209" data-mp="cav5uyth5j5i">
            <p className="text-[clamp(20px,2.4vw,50px)] leading-none text-[#F4F7FC]" style={{
            fontFamily: 'var(--font-serif)'
          }} data-id="element-210" data-mp="cdhez2w0k6pu">
              100K+
            </p>
            <p className="mt-[1vh] text-[clamp(7.5px,0.78vw,16px)] uppercase tracking-[0.18em] text-[#7C8699]" data-id="element-211" data-mp="21ubk2vw3r8jw">
              Capital organizations
            </p>
          </div>
          <div data-id="element-212" data-mp="1s0uq9rvyttg8">
            <p className="text-[clamp(20px,2.4vw,50px)] leading-none text-[#F4F7FC]" style={{
            fontFamily: 'var(--font-serif)'
          }} data-id="element-213" data-mp="1s0mfq6nbf087">
              35K+
            </p>
            <p className="mt-[1vh] text-[clamp(7.5px,0.78vw,16px)] uppercase tracking-[0.18em] text-[#7C8699]" data-id="element-214" data-mp="1i26m9x0tfevj">
              Institutional LPs
            </p>
          </div>
        </div>
        <Caption className="max-w-[46%] text-right" data-id="element-215" data-mp="195xmgh8xee8v">
          Addressable organizational universe. Revenue potential is modeled
          bottom-up from published workspace and engagement pricing.
        </Caption>
      </Reveal>
    </Slide>;
}